import { groupBy } from 'lodash';
import { useSelector } from 'react-redux';
import { useFinancialPlanQuery } from '../../../../../api/useFinancialPlanQuery';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { selectEstatePlanningDocumentTypes, selectEstatePlanningGoal } from './Checklist.selectors';

interface UseChecklistParams {
  isPrint: boolean;
}

export const useChecklist = ({ isPrint }: UseChecklistParams) => {
  const { clientId, goalId } = useRouteParams();

  const queryResult = useFinancialPlanQuery();

  const legacyGoal = useSelector(state => isPrint && selectEstatePlanningGoal(state));

  const legacyDocumentTypes = useSelector(
    state => isPrint && selectEstatePlanningDocumentTypes(state),
  );

  if ((!isPrint && !queryResult.data) || (isPrint && !legacyGoal)) {
    return null;
  }

  const goal = isPrint
    ? legacyGoal
    : queryResult.data?.Goals.find(_goal => _goal.GoalId === goalId);

  const documentTypes = isPrint
    ? legacyDocumentTypes
    : queryResult.data?.EstatePlanningDocumentsOption;

  const documentGroups = Object.entries(groupBy(goal.Documents, 'DocumentType')).map(
    ([documentType, documents]) => ({
      id: documentType,
      name: documentTypes[documentType].label,
      documents,
    }),
  );

  return {
    documentGroups,
    documentTypes,
    clientId,
    goal,
  };
};
